import { Card, CardContent, Grid } from '@material-ui/core'
import {
  components,
  constants,
  useTranslation
} from 'cng-web-lib'

import AccessLevelRuleApiUrls from 'src/apiUrls/AccessLevelRuleApiUrls'
import React from 'react'
import AccessLevelRuleKeys from 'src/constants/locale/key/AccessLevelRule'
import Namespace from 'src/constants/locale/Namespace'

const {
  card: { CngSimpleCardHeader },
  table: {
    CngCrudTable,
    useDefaultNotification
  }
} = components

const {
  locale: {
    key: { UiComponentKeys }
  }
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([
    Namespace.UI_COMPONENT,
    Namespace.ACCESS_LEVEL_RULE
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let accessLevelRule = translate(
      Namespace.ACCESS_LEVEL_RULE,
      AccessLevelRuleKeys.TITLE
    )
    let tableTitle = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Table.TITLE,
      {
        nameTitleised: accessLevelRule
      }
    )
    let name = translate(
      Namespace.ACCESS_LEVEL_RULE,
      AccessLevelRuleKeys.NAME
    )
    let active = translate(
      Namespace.ACCESS_LEVEL_RULE,
      AccessLevelRuleKeys.ACTIVE
    )

    return {
      accessLevelRule,
      tableTitle,
      name,
      active
    }
  }

  const columns = [
    {
      field: 'name',
      title: translatedTextsObject.name,
    },
    {
      field: 'active',
      title: translatedTextsObject.active,
      type: 'boolean'
    }
  ];

	return (
    <Card>
      <CngSimpleCardHeader title={translatedTextsObject.tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
							fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: AccessLevelRuleApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              exportData={{ url: AccessLevelRuleApiUrls.EXPORT }}
              fetch={{ url: AccessLevelRuleApiUrls.GET }}
              idAccessor='id'
              notification={notification}
              //tableConfigurationCode='REPLACE_WITH_CORE_TABLE_CONFIG_CODE'
              viewRoute={`${pathname}/view`}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default TablePage
